module.exports = __webpack_public_path__ + "img/twitter.ff074cb9.svg";